<template>
  <div class="content" style="overflow:auto;height:100%;">
    <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item class="buildItem">项目管理</el-breadcrumb-item>
      <el-breadcrumb-item>
        <a to="/build">质量监控</a>
      </el-breadcrumb-item>
    </el-breadcrumb>-->
    <div class="build-CURD">
      <div class="build-table ceshi">
        <el-table
          class="ceshi"
          :data="tableData"
          style="width: 100%; background-color:#fff;"
          height="100%"
          stripe
          :header-row-class-name="tableHead"
          :header-cell-class-name="tableHeadCell"
          :header-cell-style="{background:'#fff',color:'#6C6C6C'}"
          :cell-style="{background:'#FBFBFB',color:'#6C6C6C',}"
          @row-click="openDetails"
        >
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <!-- <el-table-column label="序号">
            <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
            </template>
          </el-table-column>-->
          <el-table-column label="报警来源">
            <template slot-scope="scope">
              <span>{{scope.row.projectName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="报警原因">
            <template slot-scope="scope">
              <span>{{ scope.row.reason_str }}</span>
            </template>
          </el-table-column>
          <el-table-column label="报警次数">
            <template slot-scope="scope">
              <span>{{ scope.row.count }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备编号">
            <template slot-scope="scope">
              <span>{{ scope.row.device_id}}</span>
            </template>
          </el-table-column>
          <el-table-column label="监测位置">
            <template slot-scope="scope">
              <span>{{ scope.row.location}}</span>
            </template>
          </el-table-column>
          <el-table-column label="报警时间">
            <template slot-scope="scope">
              <span>{{scope.row.create_date}}</span>
            </template>
          </el-table-column>
          <el-table-column label="处理状态">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.dispose_status==1"
                size="mini"
                type="success"
                @click="handleEdit(scope.$index, scope.row)"
              >已处理</el-button>
              <el-button
                v-if="scope.row.dispose_status==0"
                size="mini"
                type="warning"
                @click="handleEdit(scope.$index, scope.row)"
              >未处理</el-button>
            </template>
          </el-table-column>

          <!-- 编辑窗口 -->
          <!-- <el-dialog
            title="编辑"
            :visible.sync="editFormVisible"
            center
            :append-to-body="true"
            :before-close="handleClose"
            :lock-scroll="false"
            width="30%"
          >
            <el-form :model="editForm" ref="editForm">
              <el-form-item label="名称：">
                <el-input v-model="editForm.name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="楼号：">
                <el-input v-model="editForm.type" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="类型：">
                <el-input v-model="editForm.adddress" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="所属：">
                <el-input v-model="editForm.people" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="人数：">
                <el-input v-model="editForm.contract" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
          </el-dialog>-->
        </el-table>
      </div>
      <!-- 分页展示 -->
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[3, 5, 10,20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
      ></el-pagination>-->
    </div>
  </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      tableData: [], //获取数据
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      projectId: '',
      dataText: '数据加载中...',
      tabTitle: '',
      num: {
        cjCount: 0,
        glCount: 0,
        grCount: 0,
        tzCount: 0
      },
      groupId: '',
      joinType: '2',
      times:util.myTime.getCurTime()
    }
  },

  mounted() {
    
    this.groupId = util.session.get('groupId')
    this.joinType = util.session.get('roleId')=='3'?'3':'2'
    if(util.session.get('token')&&util.session.get('token')!=''){
      this.getData()
    }
  },
  computed: {
    getTime() {
      return this.$store.state.myTime //需要监听的数据
    }
  },
  watch: {
    getTime: function(val, old) {
      this.times = this.$store.state.myTime
      if(util.session.get('token')&&util.session.get('token')!=''){
        this.getData()
      }
      
    }
  },
  methods: {
    //表头行样式
    tableHead({ row, rowIndex }) {
      return 'table-head'
    },
    //表头空格样式
    tableHeadCell({ row, rowIndex }) {
      return 'table-head-cell'
    },
    openDetails(row) {
      // console.log(111)
      util.session.set('proId', row.project_id)
      if (row.state == 1) {
        this.$router.push({ name: 'towerCon' })
      }
      if (row.state == 2) {
        this.$router.push({ name: 'lift' })
      }
      if (row.state == 3) {
        this.$router.push({ name: 'highFormwork' })
      }
      if (row.state == 4) {
        this.$router.push({ name: 'deepPit' })
      }
    },
    //获取数据
    getData() {
      var that = this
      myHttp
        .secTowerWarningInfo({
          // entId: this.groupId,
          entId: util.session.get('groupId'),
          // projectId:'',
          joinType: this.joinType,
          // joinType: '2',
          time: this.times
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              // console.log(resp)
              var list = resp.data.data.towerWarningInfo || []
              that.tableData = list
              if (list.length == 0) {
                that.dataText = '暂无数据'
              }
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    }
  }
}
</script>
<style scoped>
.build-bar span {
  margin-left: 10px;
  /* margin-right: 40px */
  font-size: 18px;
  position: relative;
}
* {
  box-sizing: border-box;
}
.content {
  height: 100%;
  background: #fff;
  /* margin-top: 20px; */
}
.build-CURD {
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
}
.build-table {
  /* height: calc(100% - 160px);
   */
  height: 100%;
  background: #fff;
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}
.el-table th,
.el-table tr {
  background-color: #000;
}
.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}
.build-table {
  position: relative;
  width: 100%;
  margin: 0 auto;
  /* height: calc(100% - 150px); */
}
.build-bar {
  padding: 10px 20px;
  text-align: left;
}
.hand {
  cursor: pointer;
}
img {
  margin-left: 60px;
}
.table-head {
  background: #17b2fe;
}
.table-head-cell {
  background: #17b2fe;
  color: #fff;
}

.el-table--enable-row-hover .el-table__body tr > td {
  background-color: #fff !important;
}
.ceshi >>> .el-table td,
.ceshi >>> .el-table th.is-leaf {
  border-bottom: 10px solid #fff;
}
.ceshi >>> .el-table th.is-leaf {
  border-bottom: 10px solid #f5f5f5;
}
.ceshi >>> .el-table:before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}
/* .el-table__body-wrapper {
  overflow: auto;
  height: calc(100% - 50px);
  position: relative;
} */
</style>
<style>
.head-type span {
  margin-left: 0 !important;
}
.el-menu.el-menu--horizontal {
  box-shadow: none;
}
/* .el-table td{
    border-bottom: 1px solid #010D27;
} */
</style>
<style>
</style>